<template>
  <div class="VideoItem" v-bind:class="{ VideoItemActive: activeVideo}" v-if="video.asset">
    <div class="VideoArea">
      <div class="ThumbnailWrapper">
        <video ref="video" :poster="videoThumbnailURL" preload="none"/>
      </div>
      <div class="ThumbnailOverlay">
        <div class="HitAreaLeft" v-on:click="prevFrame">
          <div></div>
        </div>
        <div class="HitAreaPlay" v-on:click="selectVideo">
          <div></div>
        </div>
        <div class="HitAreaRight" v-on:click="nextFrame">
          <div></div>
        </div>
      </div>
    </div>
    <div class="progressBar">
      <div class="progressBarFill" v-bind:style='{"width":percentCompelete + "%"}'></div>
    </div>
    <div class="Title">
      <div class="VideoTitleText clickable" v-on:click="openVideo"><span>{{videoTitle}}</span><span class="material-icons icon-button">open_in_new</span></div>
      <div><span v-if="formattedTime" class="TimeElapsed">{{formattedTime}}</span></div>
    </div>
  </div>
</template>

<script>
import Hls from 'hls.js';

export default {
  name: 'VideoItem',
  props: {
    video: Object
  },
  data () {
    return {
      StoryboardPosition: 0,
      StoryboardTimeCodes: [1,2,3,4,5,6],
      playing: false,
      percentCompelete: 0,
      timeRemaining: null,
      currentTime: null
    }
  },
  mounted: function() {
    if (this.video.asset) {
      var video = this.$refs["video"]
      video.addEventListener("timeupdate", this.timeUpdate);
      if(Hls.isSupported()) {
        var hls = new Hls();
        hls.loadSource(this.videoSourceURL);
        hls.attachMedia(video);
        //console.log(video)
      }
    }
  },
  computed: {
    formattedTime() {
      if (this.currentTime != null) {
        var minutes = Math.floor(this.currentTime / 60);
        var seconds = this.currentTime % 60
        var prettySeconds
        var prettyMinutes
        if (seconds < 10) {
          prettySeconds = "0" + seconds
        } else {
          prettySeconds = seconds
        }
        if (minutes > 0) {
          prettyMinutes = minutes
        } else {
          prettyMinutes = 0
        }
        return prettyMinutes + ":" + prettySeconds
      } else {
        return null
      }
    },
    playbarStyle() {
      if (this.playing) {
        return {
          "animation-name": "example",
          "animation-duration": "4s"
        }
      } else {
        return {
          "width": this.percentCompelete + "%"
        }
      }
    },
    activeVideo () {
      if (this.$store.state.nowPlaying === this.video.id) {
        return true
      } else {
        return false
      }
    },
    videoSourceURL () {
      if (this.video.asset) {
        return 'https://stream.mux.com/' + this.video.asset.muxPlaybackID + '.m3u8?token=' + this.video.asset.muxVideoToken
      } else {
        return null
      }
    },
    mp4Url () {
      if (this.video.asset) {
        return 'https://stream.mux.com/' + this.video.asset.muxPlaybackID + '/high.mp4?token=' + this.video.asset.muxVideoToken
      } else {
        return null
      }
    },

    videoThumbnailURL () {
      if (this.video.asset) {
        return 'https://image.mux.com/' + this.video.asset.muxPlaybackID + '/thumbnail.jpg?token=' + this.video.asset.muxThumbnailToken
      } else {
        return null
      }
    },
    videoTitle () {
      if (this.directions[this.video.direction.id]) {
        return this.directions[this.video.direction.id].name + " " + this.video.number
      } else {
        return null
      }
    },
    directions (){
      return this.$store.state.directionCollection;
    }
  },
  methods: {
    timeUpdate(){
      var duration = this.$refs["video"].duration
      var time = this.$refs["video"].currentTime
      this.percentCompelete = Math.floor((time/duration)*100)
      this.currentTime = Math.floor(time)
    },
    openVideo() {
      this.$store.commit('setCurrentVideo',this.video.id);
    },
    selectVideo(){
      if (this.playing) {
        this.$refs["video"].pause();
      } else {
        this.$refs["video"].play();
        if (!this.currentTime) {
          this.currentTime = 0;
        }
        this.$store.commit('setNowPlaying',this.video.id);
        //this.$emit('playbackStarted');
      }
      this.playing = !this.playing
    },
    nextFrame() {
      if (this.playing) {
        this.$refs["video"].pause();
        this.playing = false
      }
      var nextSecond = this.$refs["video"].currentTime + .5
      if (nextSecond > this.$refs["video"].duration) {
        this.$refs["video"].currentTime = 0;
      } else {
        this.$refs["video"].currentTime = nextSecond
      }
    },
    prevFrame() {
      if (this.playing) {
        this.$refs["video"].pause();
        this.playing = false
      }
      if (this.StoryboardPosition == 0) {
        this.StoryboardPosition = this.StoryboardTimeCodes.length-1;
      } else {
        this.StoryboardPosition -= 1;
      }
      this.$refs["video"].currentTime = this.StoryboardTimeCodes[this.StoryboardPosition]
    }
  },
  watch: {
    '$store.state.nowPlaying': function() {
      var paused = this.$refs["video"].paused
      if (this.$store.state.nowPlaying != this.video.id && !paused) {
        this.$refs["video"].pause();
      }
    }
  }
}
</script>

<style lang="scss">
  .progressBar {
    height: 6px;
    background-color: #2E303A60;
    border-radius: 0px 0px 5px 5px;
    overflow: hidden;
  }
  .progressBarFill {
    transition: opacity .5s;
  }
  .VideoItem:not(.VideoItemActive) .progressBarFill {
    height: 100%;
    background-color: #6A7CE9;
    opacity: .3;
  }
  .VideoItem.VideoItemActive .progressBarFill {
    height: 100%;
    background-color: #6A7CE9;
    opacity: 1;
  }
  .VideoItem {
    width: 100%;
    margin-right: 20px;
    margin-top: 20px;
  }
  .VideoArea {
    position: relative;
    height: 375px;
    border-radius: 5px 5px 0px 0px;
    overflow: hidden;
  }
  .ThumbnailWrapper {
    position: absolute;
    height: 100%;
    width: 100%;
  }
  .ThumbnailWrapper video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 50% 50%
  }
  .Title {
    padding: 10px 0px;
    display: flex;
  }

  .VideoTitleText {
    flex-grow: 1;
    display: flex;
    align-items: center;
    .icon-button {
      margin-left: 7px;
      font-size: 20px;
    }
    &:not(:hover) .icon-button{
      opacity: 0;
    }
    &:hover .icon-button{
      opacity: 1;
    }
  }
  .VideoItem.VideoItemActive .TimeElapsed {
    opacity: .6
  }
  .VideoItem:not(.VideoItemActive) .TimeElapsed {
    opacity: .1
  }
  .VideoItem:hover .ThumbnailOverlay {
    visibility: visible;
  }
  .VideoItem:not(:hover) .ThumbnailOverlay {
    visibility: hidden;
  }
  .ThumbnailOverlay {
    height: 100%;
    width: 100%;
    position: absolute;
    transition: visibility 0s, opacity 0.2s ease;
  }
  .ThumbnailOverlay {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
  }
  .ThumbnailOverlay >div {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ThumbnailOverlay >div div {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    text-decoration: none;
  }
  .HitAreaRight, .HitAreaLeft {
    width: 25%;
    cursor: pointer;
  }
  .HitAreaPlay {
    flex-grow: 1;
    cursor: pointer;
  }
  .HitAreaRight {
    background: rgb(255,255,255);
    background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(0,0,0,0) 100%);
  }
  .HitAreaLeft {
    background: rgb(255,255,255);
    background: linear-gradient(90deg, rgba(0,0,0,0)0%, rgba(255,255,255,0) 100%);
  }
</style>
